// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"xd","title":"xe","year":"xf","genres":"xh","buttonWrapper":"xi","button":"xj x-"};